// Currency + date formatting helpers.

const CURRENCY_LOCALE = {
  USD: "en-US", EUR: "en-IE", GBP: "en-GB", AED: "en-AE",
  TRY: "tr-TR", JPY: "ja-JP", INR: "en-IN", CNY: "zh-CN",
  THB: "th-TH", IDR: "id-ID", EGP: "ar-EG",
};

export function fmtMoney(amount, currency = "USD", opts = {}) {
  if (amount === null || amount === undefined || isNaN(amount)) return "—";
  const locale = CURRENCY_LOCALE[currency] || "en-GB";
  try {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency,
      minimumFractionDigits: opts.minimumFractionDigits ?? 0,
      maximumFractionDigits: opts.maximumFractionDigits ?? 2,
    }).format(amount);
  } catch {
    return `${currency} ${Number(amount).toLocaleString()}`;
  }
}

export function fmtGBP(amount) {
  return fmtMoney(amount, "GBP", { maximumFractionDigits: 0 });
}

export function fmtUsdMinor(amountMinor) {
  if (amountMinor === null || amountMinor === undefined || isNaN(amountMinor)) return "—";
  return fmtMoney(Number(amountMinor) / 100, "USD");
}

export function fmtDate(iso, withTime = false) {
  if (!iso) return "—";
  const d = typeof iso === "string" ? new Date(iso) : iso;
  if (isNaN(d.getTime())) return "—";
  const opts = withTime
    ? { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }
    : { day: "2-digit", month: "short", year: "numeric" };
  return new Intl.DateTimeFormat("en-GB", opts).format(d);
}

export function fmtRelative(iso) {
  if (!iso) return "—";
  const d = typeof iso === "string" ? new Date(iso) : iso;
  const diffMs = Date.now() - d.getTime();
  const sec = Math.round(diffMs / 1000);
  if (sec < 60) return `${sec}s ago`;
  const min = Math.round(sec / 60);
  if (min < 60) return `${min}m ago`;
  const hr = Math.round(min / 60);
  if (hr < 24) return `${hr}h ago`;
  const day = Math.round(hr / 24);
  if (day < 30) return `${day}d ago`;
  return fmtDate(d);
}

export function titleCase(s) {
  if (!s) return "";
  return s
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export function statusVariant(status) {
  if (!status) return "neutral";
  const s = status.toLowerCase();
  if (["approved", "published", "paid", "confirmed", "completed", "active", "verified", "issued"].includes(s)) return "success";
  if (["pending", "pending_review", "processing", "in_progress", "invited", "waiting_supplier", "waiting_customer", "pending_moderation"].includes(s)) return "warning";
  if (["rejected", "failed", "cancelled", "refunded", "urgent", "flagged", "high", "partially_refunded", "on_hold", "suspended", "missing"].includes(s)) return "danger";
  return "neutral";
}
